
/**
 * Returns the user's token. This function simply needs to make a retrieval
 * call to wherever the token is stored. In many cases, the token will be
 * stored in local storage or session storage.
 * @returns Returns the user's token.
 */
// export function tokenGetter(): string {
//     return localStorage.getItem('auth_token') || '';
//     // return localStorage.getItem(tokenKey) || '';
// }

import { Configuration } from "./services/env-configuration.service";

/**
 * Factory for generating the configuration for the JwtModule.
 * @returns an object containing the desired options under the 'options' property
 * and a method to update the allowedDomains.
 */
export function jwtConfigurationFactory(): {
    options: () =>
        {
            tokenGetter: () => string;
            allowedDomains: any[];
            disallowedRoutes: any[];
        };
    updateConfig: (config: Configuration) => void
} {
    const allowedDomains: string[] = [];
    const disallowedRoutes: string[] = [];
    let tokenGetter = () => {
        return ''
    };

    /**
     * Clears the old entries and sets the allowed domains to the given value
     */


    function updateConfig(config: Configuration) {
        while (allowedDomains.length > 0) {
            allowedDomains.pop();
        }
        allowedDomains.push(...[config.apiDomain]);
        while (disallowedRoutes.length > 0) {
            disallowedRoutes.pop();
        }
        disallowedRoutes.push(...[config.identityApiUrl]);
        tokenGetter = () => {
            return localStorage.getItem(config.tokenKey) || ''
        }
    }

    return {
        updateConfig,
        options: () => ({
            tokenGetter,
            allowedDomains,
            disallowedRoutes,
        })
    };
}

/**
 * Saves an instance of the object returned by jwtConfigurationFactory.
 * the options property can be passed to angular-jwt.
 * This object can be used to access the allowedDomains afterwards.
 */
export const jwtOptions = jwtConfigurationFactory();